import { makeAutoObservable } from 'mobx';
import { ReportBI } from '../services';
import { ConditionalModalState } from './ConditionalModalState';
import { FieldOperationsBIReporter } from './FieldOperationsBIReporter';
import { FieldArchive, FieldManagement } from '../types/FieldsSource';

export interface DeleteFieldModalStateParams {
  readonly fieldManagement: Pick<FieldManagement, 'deleteField'>;
  readonly archive: Pick<FieldArchive, 'items' | 'closePanel'>;
  readonly reportBi: ReportBI;
}

export class DeleteFieldModalState {
  readonly biReporter;
  readonly fieldManagement;
  readonly archive;
  readonly modal;

  constructor(params: DeleteFieldModalStateParams) {
    this.biReporter = new FieldOperationsBIReporter({
      reportBi: params.reportBi,
    });
    this.fieldManagement = params.fieldManagement;
    this.archive = params.archive;
    this.modal = new ConditionalModalState<{
      id: string;
      origin: string;
      fieldName: string;
    }>({
      onConfirm: async () => {
        if (!this.modal.value) {
          return;
        }

        this.biReporter.reportDeleteFieldModalCtaClicked('Delete');
        await this.fieldManagement.deleteField(
          this.modal.value.id,
          this.modal.value.origin,
        );

        // Close archived panel if no items left
        if (this.archive.items.length === 0) {
          this.archive.closePanel();
        }
      },
      onClose: () => {
        this.biReporter.reportDeleteFieldModalCtaClicked('Cancel');
      },
    });
    makeAutoObservable(this);
  }
}
